import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AuthService} from './services/auth.service';
import {Observable, switchMap, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

  // tslint:disable-next-line:ban-types
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<Object>> {
    const authToken = this.authService.getAuthorizationHeaderValue();
    const authReq = req.clone({ setHeaders: { Authorization: authToken } });
    return next.handle(authReq).pipe(catchError(error => {
      return this.handleError(error, req, next);
    }));
  }

  private handleError(error: any, request: HttpRequest<any>, next: HttpHandler): Observable<any>{
    const errorUnauthorized = 401;
    if (error.status === errorUnauthorized){
      return this.authService.silentSignIn().pipe(switchMap(() => {
        const authToken = this.authService.getAuthorizationHeaderValue();
        const authReq = request.clone({ setHeaders: { Authorization: authToken } });
        return next.handle(authReq);
      }));
    }

    return throwError(() => error);
  }
}
